"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _KnockTypes = require("../../../../constants/KnockTypes");
var _utils = require("../../../../utils");
var _KnockItemHeader = require("./KnockItemHeader.styled");
var _knockTypeMap;
var KnockItemHeader = function KnockItemHeader(_ref) {
  var type = _ref.type,
    presenterName = _ref.presenterName,
    _ref$captitalizeTitle = _ref.captitalizeTitle,
    captitalizeTitle = _ref$captitalizeTitle === void 0 ? true : _ref$captitalizeTitle;
  var _knockTypeMap$type = knockTypeMap[type],
    icon = _knockTypeMap$type.icon,
    actionText = _knockTypeMap$type.actionText;
  var getNotificationTitle = function getNotificationTitle(type) {
    if (type === _KnockTypes.SCREENSHARE) {
      return 'Screen share';
    }
    return 'Speaker';
  };
  var title = getNotificationTitle(type);
  return /*#__PURE__*/_react["default"].createElement(_KnockItemHeader.KnockItemHeaderContainer, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: "#6E7582",
    icon: icon
  }), /*#__PURE__*/_react["default"].createElement(_KnockItemHeader.KnockItemHeaderInfo, null, /*#__PURE__*/_react["default"].createElement(_KnockItemHeader.KnockItemHeaderTitle, {
    captitalizeTitle: captitalizeTitle
  }, title), /*#__PURE__*/_react["default"].createElement(_KnockItemHeader.KnockItemHeaderRequest, {
    className: "dd-privacy-mask"
  }, (0, _utils.truncate)(presenterName), " wants to ", actionText)));
};
var knockTypeMap = (_knockTypeMap = {}, (0, _defineProperty2["default"])(_knockTypeMap, _KnockTypes.PRESENTER, {
  icon: _freeSolidSvgIcons.faUser,
  actionText: 'join'
}), (0, _defineProperty2["default"])(_knockTypeMap, _KnockTypes.SCREENSHARE, {
  icon: _freeSolidSvgIcons.faDesktop,
  actionText: 'screen share'
}), _knockTypeMap);
KnockItemHeader.propTypes = {
  type: _propTypes["default"].string.isRequired,
  presenterName: _propTypes["default"].string,
  captitalizeTitle: _propTypes["default"].bool
};
var _default = exports["default"] = KnockItemHeader;